import { InjectionToken } from '@angular/core';
import type { GraphQLErrorHandler, GraphQLTranslationError } from '../graphql.types';

const defaultErrorHandler: GraphQLErrorHandler = {
  handleGraphQLErrors(errors: readonly GraphQLTranslationError[]): void {
    for (const error of errors) {
      console.error(`[GraphQL Error ${error.statusCode}]: ${error.message}`);
    }
  },
  handleNetworkError(error: Error, statusCode?: number): void {
    console.error(`[Network Error${statusCode != null ? ` ${statusCode}` : ''}]:`, error.message);
  },
};

export const GRAPHQL_ERROR_HANDLER = new InjectionToken<GraphQLErrorHandler>(
  'GraphQLErrorHandler',
  { factory: () => defaultErrorHandler },
);
